import React from 'react';
// import ReactPlayer from 'react-player';
import ResponsiveImageMobile from 'components/images/ResponsiveImage';
import AnimatedSingleSquare from 'components/images/AnimatedSingleSquare';
import Fade from 'react-reveal/Fade';

import {
  BlackSlideMobile,
  SlideMobile,
  BigText,
  Row,
  MedText,
  // PlayerWrapper,
  FactRow,
  Fact,
  PressRow,
  PressItem
} from '../styles';

import { keyFacts, pressLogos } from 'data/home';
import { workspacesRotatingImages } from 'data/rotatingImages';

const generatePressGrid = () => {
  const rows = [];
  let cols = [];

  pressLogos.forEach((el, idx) => {
    cols.push(
      <PressItem href={el.href} target="_blank" key={`row-${idx}-el-${idx}`}>
        <img src={el.logo} alt={`${el.alt} logo`} className="press-logo" />
      </PressItem>
    );

    if ((idx + 1) % 3 === 0) {
      rows.push(<PressRow key={`fact-${idx}`}>{cols}</PressRow>);
      cols = [];
    }
  });

  return rows;
};

const generateFacts = () => {
  const rows = [];
  let cols = [];
  keyFacts.forEach((el, idx) => {
    cols.push(
      <Fact key={`fact-${idx}`} index={idx + 1}>
        <p className="fact-index">{idx + 1}</p>
        <p className="fact-body">{el}</p>
      </Fact>
    );
    if ((idx + 1) % 2 === 0) {
      rows.push(<FactRow key={`fact-${idx}`}>{cols}</FactRow>);
      cols = [];
    }
  });
  return rows;
};

const SectionThreeMobile = () => {
  return (
    <React.Fragment>
      <BlackSlideMobile>
        <Fade right>
          <div className="flex-column-center">
            <h1 className="quote">
              "The thing that’s unique about the ROW is that it’s this incredible modern space, but
              it’s also really historied. The buildings are over 100 years old and so when you’re
              walking through campus, there’s not really many places in LA where you can really feel
              like you’re a part of LA’s history."
            </h1>
            <span className="credit">RACHEL MADDEN, WC+A</span>
          </div>
        </Fade>
      </BlackSlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_1" />
          <Row paddingBottom="0">
            <BigText className="black-500">
              A dynamic destination molded through curated, elevated experiences{' '}
            </BigText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_2" />
          <Row paddingBottom="0">
            <MedText className="black-500">
              Gaining momentum as the creative centerpiece of LA, ROW DTLA sets the tone for a new
              spin on offline experiences and a luxurious lifestyle
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_3" />
          <Row paddingBottom="0">
            <BigText className="black-500">
              Unmatched level of installations, events, pop-ups, and more
            </BigText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <AnimatedSingleSquare imgArray={workspacesRotatingImages} active />
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_10" />
          <Row paddingBottom="0">
            <MedText className="black-500">
              Monthly, weekly and daily events constantly create unique interactions connecting
              retailers to consumers, all occurring at a thriving, open-air mecca of contemporary
              culture
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_11" />
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <BigText className="black-500" style={{ margin: '1em 0' }}>
          Key facts
        </BigText>
        {generateFacts()}
      </SlideMobile>
      <SlideMobile>
        <BigText className="black-500" style={{ margin: '1em 0' }}>
          In the press
        </BigText>
        {generatePressGrid()}
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_3/ROWDTLA_retail-brochure_section3_12" />
          <Row>
            <BigText className="black-500">ROW DTLA. Work life has never looked better.</BigText>
          </Row>
        </Fade>
      </SlideMobile>
    </React.Fragment>
  );
};

export default SectionThreeMobile;
